const links = [
  { label: 'Who We Are', url: '/who-we-are' },
  { label: 'What We Do', url: '/what-we-do' },
  { label: 'contact Us', url: '/contact-us' },
  // { label: 'Get Involved', url: '/highlights' },
  // { label: 'Highlights + Events', url: '/highlights' }
]

export default links
